import styled from 'styled-components'
import FormControl from '@material-ui/core/FormControl';

export const FormControls = styled(FormControl)`
    &.MuiFormControl-root {
        min-width: 120px;
    }
`
